import React from 'react'
import { Logo } from '@wallyhealth/web-core'
import styles from './index.module.css'

const CenteredLayout = ({ children }) => (
  <div className={styles.page}>
    <div className={styles.logoBar}>
      <Logo className={styles.logo} color="black" />
    </div>
    <div className={styles.center}>
      <div className={styles.block}>
        {children}
      </div>
    </div>
  </div>
)

export default CenteredLayout
